/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Vacation = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        employeeId: {
    type: 'number',
    isRequired: true,
},
        date: {
    type: 'string',
    isRequired: true,
    format: 'date',
},
        reason: {
    type: 'string',
},
        createdAt: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
    },
};